import React from "react";
import {  useSelector , useDispatch} from 'react-redux'; 

import { modifyChampsLeadmemo } from '../../state/redux';

import './DatePrelevement.scss';
const classNames = require('classnames');
function StatutMatrimonial() {
       const dispatch = useDispatch()
       const leadmemo  = useSelector(state=>state.lead.leadmemo);

    const definestatutmatrimonial= (e)=>{  dispatch(modifyChampsLeadmemo({'statut_matrimonial':e.target.id }))}

    return ( <div className="wd250"> 
                            <div className='dateprelevement_label' >
                                 Statut matrimonial
                            </div>
                           <div className='dateprelevement_list' >
                                <div id="marie"  onClick={definestatutmatrimonial}  className={classNames("clickchoice",{'isvalid':leadmemo.statut_matrimonial==="marie"},{'notvalid':leadmemo.statut_matrimonial!=="marie"})}>Marié</div>
                                <div id="celibataire"  onClick={definestatutmatrimonial}  className={classNames("clickchoice",{'isvalid':leadmemo.statut_matrimonial==="celibataire"},{'notvalid':leadmemo.statut_matrimonial!=="celibataire"})}>Célibataire</div>
                                 <div id="autre"  onClick={definestatutmatrimonial}  className={classNames("clickchoice",{'isvalid':leadmemo.statut_matrimonial==="autre"},{'notvalid':leadmemo.statut_matrimonial!=="autre"})}>Autre</div>
                            </div>
                     
                       
                </div>)
}


export default   StatutMatrimonial  